import React from "react";

interface IMarker {
    lat: number;
    lng: number;
}

const Marker: React.FC<IMarker> = ({ lat, lng }) => {
    return (
        <div
            style={{
                color: "white",
                display: "inline-flex",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "100%",
                transform: "translate(-50%, -50%)",
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="75"
                height="75"
                version="1.1"
                viewBox="0 0 7.937 7.938"
            >
                <g>
                    <path
                        fill="#06b66c"
                        fillOpacity="1"
                        fillRule="evenodd"
                        strokeWidth="0.173"
                        d="M3.764.309a1.896 1.896 0 00-1.896 1.896 1.896 1.896 0 00.19.824l.814 2.173.904 2.41.898-2.415.898-2.415h-.003a1.896 1.896 0 00.09-.577A1.896 1.896 0 003.764.309z"
                    ></path>
                    <circle
                        cx="3.766"
                        cy="2.239"
                        r="1.745"
                        fill="#008b52"
                        fillOpacity="1"
                        stroke="#fff"
                        strokeDasharray="none"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="0"
                    ></circle>
                    <g
                        fill="none"
                        stroke="#fff"
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="2.165"
                        transform="matrix(.04036 0 0 .038 .893 2.585)"
                    >
                        <path d="M51.401-1.174c-1.132-.579-.878-2.256-.92-3.333-.497-13.205-.732-38.183-.732-38.183l1.493-2.295s.385-.423.114-.241c0 0-10.162 5.263-9.925 9.168.588 9.674 1.587 50.886 1.587 50.886s1.073 6.842 7.658 2.874C57.26 13.734 83.41-.732 83.556-1.36c.251-1.092-20.126 6.333-32.155.186z"></path>
                        <path d="M70.284-32.548c1.071-.685 2.391.38 3.34.89 11.65 6.236 33.331 18.644 33.331 18.644l1.227 2.448s.17.546.15.22c0 0 .588-11.43-2.903-13.196-8.648-4.377-44.726-24.321-44.726-24.321s-6.447-2.529-6.347 5.159c.1 7.687-.614 37.563-.145 38.005.815.769 4.694-20.57 16.073-27.849z"></path>
                        <path d="M87.95.025c.072 1.27-1.504 1.897-2.413 2.475C74.387 9.592 52.94 22.396 52.94 22.396l-2.736-.132s-.559-.118-.265.024c0 0 9.671 6.119 12.923 3.944C70.918 20.844 105.997-.81 105.997-.81s5.367-4.378-1.381-8.062c-6.748-3.684-32.43-18.964-33.047-18.772C70.5-27.31 87.19-13.461 87.951.025z"></path>
                    </g>
                </g>
            </svg>
        </div>
    );
};
export default Marker;
